
export enum ItemType {
    competition = 'competition',
    book = 'book',
    shortlist = 'shortlist',
    other = 'other',
    showcase = 'showcase',
    mapItem = 'mapItem'
}

export enum ItemType {
    competition = 'competition',
    book = 'book',
    shortlist = 'shortlist',
    other = 'other',
    showcase = 'showcase',
    mapItem = 'mapItem'
}
